import { render, staticRenderFns } from "./PacientesEsperaUrgencias.vue?vue&type=template&id=067757c1&"
import script from "./PacientesEsperaUrgencias.vue?vue&type=script&lang=js&"
export * from "./PacientesEsperaUrgencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports